module.exports = __webpack_public_path__ + "img/img_loginbg@2x.58158477.png";